module.exports = __webpack_public_path__ + "static/media/cursor_play.ca402374.svg";